module.exports = __webpack_public_path__ + "img/scope5.9fb68084.png";